import Layout2 from '@/layout/Layout.vue'
import globalConstant from "@/core/data/globalConstant.js";

export default [{
  path: '/cancellation-exceptions',
  component: Layout2,
  children: [{
    path: "/cancellation-exceptions",
    name: "cancellation-exceptions",
    component: () => import("@/views/cancellations/CancellationExceptions.vue"),
    meta: {
      title: globalConstant.general.APPTITLE + ' | Cancellation Exceptions',
      auth: true,
      section: 'orders',
      allowedPermission: "request-order-cancellation"
    }
  }]
}]
